It was decided with Ronni to make a separate paage for user tryinng to sign up aggain
<template>
	<UserRegistrationLayout class="resend-verification-email">
		<SIcon name="key"></SIcon>
		<div class="slot-title">
			You’re already signed up as <span class="email-text">{{ userEmail }}</span>
		</div>
		<div class="right-side-description">
			Check your inbox for the confirmation code to activate your account<br />
			Check your spam folder as well
		</div>
		<div class="bottom-section">
			<div>
				Didn't receive an email? Try to
				<span @click="resendEmail()" class="primary-link-style ml-1">Resend email</span>
			</div>
		</div>
	</UserRegistrationLayout>
</template>

<script>
import UserRegistrationLayout from './UserRegistrationLayout';
import UserRegistrationMixin from './helpers/UserRegistrationMixin';

export default {
	name: 'ResendVerificationEmail',
	components: {
		UserRegistrationLayout,
	},
	props: {
		userEmail: { type: String },
	},
	mixins: [UserRegistrationMixin],
};
</script>

<style scoped lang="scss">
.resend-verification-email {
	.right-side-section {
		.slot-title {
			margin: 30px 0 40px;
		}
	}

	.email-text {
		color: var(--primary-color);
	}
}
</style>
